import { Container, Typography } from '@mui/joy'

export function PrivacyPolicyPage() {
    return (
        <Container sx={{ pb: '2rem' }}>
            <Typography
                level="h1"
                sx={{ width: '100%', textAlign: 'center', py: '2rem' }}
            >
                Privacy Policy
            </Typography>

            <Typography level="title-sm">
                Effective date: 21 October 2024
            </Typography>
            <Typography textAlign={'justify'} sx={{ pt: '1rem' }}>
                This Privacy & Security Policy (hereinafter referred to as the
                "Policy") regulates how our mobile application EzyMoney
                (hereinafter also referred to as the "App"), our website{' '}
                <a href="https://ezymoney.web.app">ezymoney.web.app</a>{' '}
                (hereinafter referred to as the "Website"), and any additional
                services—such as SMS-based functionalities, expense tracking,
                and analysis—that Sachin Kumar (hereinafter referred to as the
                "Company") — makes available to you.
                <br />
                <br />
                This policy is subject to change as we develop, enhance, and
                broaden the EzyMoney App Service. Therefore, kindly consult it
                from time to time. You agree to the collection, storage, and use
                of the personal information you provide (including any updates
                you may provide) for the services we provide by using the
                Website, App, or other EzyMoney App Services.
                <br />
                <br />
                This Policy must be read in conjunction with our{' '}
                <a href="terms-of-service">Terms of Service</a>.
                <br />
                <br />
                The Company respects the privacy of the users of the EzyMoney
                Service and is committed to reasonably protecting it in all
                respects. The information about the user as collected by the
                Company includes: (a) information supplied by users and (b)
                information automatically tracked while using a mobile device
                having EzyMoney Services enabled (collectively referred to as
                "Information").
                <h4>1. INFORMATION COLLECTED</h4>
                To provide you with our services, we may collect the following
                types of information: SMS records: EzyMoney requires access to
                your SMS inbox to read transactional messages sent by banks and
                service providers. We only read transactional SMS and do not
                access personal messages, OTPs, passwords, or any other
                sensitive information. Your explicit consent is obtained before
                accessing your SMS inbox. Contacts Access: If you grant
                permission, we may access your contacts to enhance your
                experience by replacing phone numbers with names in the app.
                This permission is optional and can be granted based on the
                functionality you wish to use. Device ID: We may collect and
                store your Device ID to uniquely identify you and manage access
                to the App. Other Information: In addition, the Application may
                collect (either directly or through third-party integrated
                services such as Google Analytics, Facebook Android SDK, etc.)
                certain information automatically, including but not limited to
                the mobile device model, device name, device's serial number or
                unique identification number (e.g., Android ID or ADID on your
                Android Device), device operating system & version, and
                information about the way you use the Application. This
                information is only used to improve the Application and the
                service.
                <h4>2. Opt-Out Rights</h4>
                Users may choose to deny the SMS permission or contacts
                permission. Each of these actions would impact some
                functionality of the App, but it will continue to perform other
                functions as per the terms of the active subscription. Users may
                at any time stop the collection of information by the
                Application by uninstalling the App. Users may use the standard
                uninstall processes as may be available as part of the mobile
                device or via the mobile application or network.
                <h4>3. Purpose of Information Collection</h4>
                We collect your information to provide several services aimed at
                enhancing your experience with our app. First, we use the data
                to automatically track your expenses by analyzing your SMS
                messages, specifically focusing on transactional SMS from banks
                and service providers. Additionally, by accessing your contacts
                (with your permission), we replace phone numbers with names to
                make the app more user-friendly. We also store certain
                transactional SMS on our server to improve the accuracy of our
                machine learning model, allowing us to better identify
                transactional entities and refine our services. Lastly, the
                collected information may be used for customer support purposes,
                such as sending administrative updates, providing customer
                service, and notifying you of important changes. This
                information can be used by us to maintain, protect, and improve
                the services provided by the company or for developing new
                services. You also consent to the information obtained to be
                used in order to contact you for administrative purposes such as
                customer service, notification of major changes, and updates.
                The app may also use the information related to user spends,
                patterns, and user data to generate anonymized and aggregated
                statistics and reserves the right to this statistical data. Any
                personally identifiable information available in the public
                domain, reviews, comments, messages, or emails posted/sent by
                users becomes published content and is not considered personally
                identifiable information subject to this Privacy Policy.
                <h4>4. Data Retention, Managing Information</h4>
                Your data may be retained for a reasonable time as necessary for
                providing you the required services or your explicit request to
                delete the data, whichever is earlier.
                <h4>5. Data Security</h4>
                We take appropriate security measures to protect against
                unauthorized access, alteration, disclosure, or destruction of
                data. These include physical, electronic, and procedural
                safeguards to protect information we process and maintain.
                Please be aware that we endeavor to provide reasonable anonymity
                and security to information we process, store, maintain, and
                transmit on a best-effort basis. Access to our servers is
                password-protected and strictly limited. Note that no money can
                be moved through this App. This means that even though you can
                view accounts, analyze expenses and transactions, you or the App
                cannot transfer money from one account to another.
                <h4>6. Third parties</h4>
                The Company shall not publish, sell, give on rent, trade, or
                otherwise transfer any personally identifiable information to
                third parties except: (a) when it is authorized by you in order
                to render you specific services; (b) required by law, such as to
                comply with a legal process or when disclosure is necessary to
                protect our rights, protect your safety or the safety of others,
                investigate fraud, or respond to a government request. If the
                Company is going for a merger, acquisition, or sale of all or a
                portion of its assets, you will be notified via notice on our
                website of any change in ownership or uses of this information,
                as well as any choices you may have regarding this information.
                The Application integrates with third-party services that have
                their own privacy policies. These services may collect
                aggregated and anonymized data to enhance functionality. We are
                not responsible for how these external services handle data.
                Link to privacy policy of some of the third party service
                providers used by our app:
                <ul>
                    <li>
                        <a href="https://policies.google.com/privacy">
                            Google Play Services
                        </a>
                    </li>
                    <li>
                        <a href="https://support.google.com/admob/answer/6128543?hl=en">
                            AdMob
                        </a>
                    </li>
                    <li>
                        <a href="https://firebase.google.com/policies/analytics">
                            Google Analytics for Firebase
                        </a>
                    </li>
                    <li>
                        <a href="https://firebase.google.com/support/privacy/">
                            Firebase Crashlytics
                        </a>
                    </li>
                </ul>
                The Service Provider may also disclose information:
                <ul>
                    <li>
                        As required by law or in response to legal processes.
                    </li>
                    <li>To protect user safety or investigate fraud.</li>
                    <li>
                        To trusted service providers who comply with this
                        Privacy Policy.
                    </li>
                </ul>
                We want to inform you that whenever you use my Service, in a
                case of an error in the app, We collect data and information
                (through third party products) on your phone called Log Data.
                This Log Data may include information such as your device
                Internet Protocol (“IP”) address, device name, operating system
                version, the configuration of the app when utilizing my Service,
                the time and date of your use of the Service, and other
                statistics.
                <h4>7. Questions, Concerns or Grievance Redressal</h4>
                If you have any questions, concerns, comments, or complaints
                regarding the privacy policy or our practices, please contact us
                via email at{' '}
                <a href="mailto:kr771.sachin@gmail.com">
                    kr771.sachin@gmail.com
                </a>
                .
                <br />
                <br />
                This Privacy Policy may be updated from time to time to
                incorporate necessary changes in technology, applicable laws, or
                for any other reason. You are advised to consult this Privacy
                Policy regularly for any changes, as continued use will be
                deemed approval of all changes.
            </Typography>
        </Container>
    )
}
